//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/* global ActiveXObject: false */

(function () {
  const uia = angular.module('uia');

  uia.directive('universalImageActionsTributary', [
    function () {
      return {
        restrict: 'E',
        scope: {},
        require: '^universalImageActionsModal',
        template: require('@legacy-components/common/universal-image-actions/universal-image-actions-tributary.html'),
        controller: [
          '$scope',
          '$rootScope',
          '$window',
          'SessionVarsService',
          'ShowroomApiService',
          'ShowroomService',
          'SHOWROOM_ACTION_TYPES',
          'SHOWROOM_BUTTON_STATE',
          'SyndicationService',
          'TrackingService',
          'UniversalImageActionsHelpers',
          'UniversalImageActionsItemType',
          'UniversalImageActionsService',
          function (
            $scope,
            $rootScope,
            $window,
            SessionVarsService,
            ShowroomApiService,
            ShowroomService,
            SHOWROOM_ACTION_TYPES,
            SHOWROOM_BUTTON_STATE,
            SyndicationService,
            TrackingService,
            UniversalImageActionsHelpers,
            UniversalImageActionsItemType,
            UniversalImageActionsService,
          ) {
            const launchOptions =
              UniversalImageActionsService.getCurrentLaunchOptions();
            const universalItemId = launchOptions.getUniversalItemId();
            const TRACKING_CATEGORY =
              UniversalImageActionsHelpers.getTrackingCategory(
                UniversalImageActionsService.getCurrentPage(),
              );

            $scope.state = {
              loaded: false,
            };

            $scope.model = {
              shortenChecked: true,
              creatingLinkAsync: false,
              currentlyInWorkflow:
                !!UniversalImageActionsService.getCurrentWorkflow(),
              shortenLinkError: false,
              showroomLaunchContext:
                launchOptions.getShowroomLaunchContext() || {},
              isDesktopExperienceEnabled: SessionVarsService.isFeatureEnabled(
                'showroom_desktop_experience',
              ),
            };

            $scope.model.TRACKING_CATEGORY = TRACKING_CATEGORY;

            $scope.model.close = () => {
              $scope.$emit('uia:modal:close');
            };

            // Allow the user to preview their currently configured adaptive link. We'll
            // open a new window pointing to a dedicated mobile preview page
            $scope.model.openPreviewWindow = () => {
              $window.open($scope.state.previewUrl);
            };

            $scope.model.helpLinkClicked = () => {
              TrackingService.recordEvent(
                TRACKING_CATEGORY,
                ShowroomService.getTrackingAction(),
                'HelpLinkTopClicked',
              );
            };

            $scope.model.addAnotherLink = () => {
              TrackingService.recordEvent(
                TRACKING_CATEGORY,
                ShowroomService.getTrackingAction(),
                'AddAnotherLinkClicked',
              );
              ShowroomService.addNewInstance(
                universalItemId,
                $scope.state.impl.id,
                $scope.state.impl.name,
              );
            };

            $scope.model.onPassthroughChanged = (
              showDesktopExperience,
              passthroughUrl,
            ) => {
              ShowroomService.updatePreviewUrl(
                universalItemId,
                $scope.state.impl.id,
                $scope.state.impl.name,
                _($scope.state).safeGet('filters.filterState'),
                showDesktopExperience,
                passthroughUrl,
                _($scope.state).safeGet('useCuratedRecommendations'),
                _($scope.state).safeGet('curatedProducts'),
                _($scope.state).safeGet('selectedLabels'),
                () => {
                  ShowroomService.updatePassthrough(
                    showDesktopExperience,
                    passthroughUrl,
                  );
                },
              );
            };

            $scope.model.onFiltersUpdated = (filterState) => {
              // Because filters are tied to a toggle, update the UI immediately,
              // and update again after the async call completes (in case the call was debounced)
              ShowroomService.updateFilters(filterState);
              ShowroomService.updatePreviewUrl(
                universalItemId,
                $scope.state.impl.id,
                $scope.state.impl.name,
                filterState,
                _($scope.state).safeGet('passthrough.showDesktopExperience'),
                _($scope.state).safeGet('passthrough.passthroughUrl'),
                _($scope.state).safeGet('useCuratedRecommendations'),
                _($scope.state).safeGet('curatedProducts'),
                _($scope.state).safeGet('selectedLabels'),
                () => {
                  ShowroomService.updateFilters(filterState);
                },
              );
            };

            $scope.model.onProductsUpdated = (productList) => {
              ShowroomService.updatePreviewUrl(
                universalItemId,
                $scope.state.impl.id,
                $scope.state.impl.name,
                _($scope.state).safeGet('filters.filterState'),
                _($scope.state).safeGet('passthrough.showDesktopExperience'),
                _($scope.state).safeGet('passthrough.passthroughUrl'),
                _($scope.state).safeGet('useCuratedRecommendations'),
                productList,
                _($scope.state).safeGet('selectedLabels'),
                () => {
                  ShowroomService.updateProductsList(productList);
                },
              );
            };

            $scope.model.onLabelsUpdated = (labels) => {
              ShowroomService.updatePreviewUrl(
                universalItemId,
                $scope.state.impl.id,
                $scope.state.impl.name,
                _($scope.state).safeGet('filters.filterState'),
                _($scope.state).safeGet('passthrough.showDesktopExperience'),
                _($scope.state).safeGet('passthrough.passthroughUrl'),
                _($scope.state).safeGet('useCuratedRecommendations'),
                _($scope.state).safeGet('curatedProducts'),
                labels,
                () => {
                  ShowroomService.updateLabels(labels);
                },
              );
            };

            $scope.model.onCuratedRecommendationsUpdated = (newState) => {
              ShowroomService.updatePreviewUrl(
                universalItemId,
                $scope.state.impl.id,
                $scope.state.impl.name,
                _($scope.state).safeGet('filters.filterState'),
                _($scope.state).safeGet('passthrough.showDesktopExperience'),
                _($scope.state).safeGet('passthrough.passthroughUrl'),
                newState,
                _($scope.state).safeGet('curatedProducts'),
                _($scope.state).safeGet('selectedLabels'),
                () => {
                  ShowroomService.setUseCuratedRecommendations(newState);
                },
              );
            };

            $scope.model.shortenLinkChanged = function () {
              if (!$scope.model.shortenChecked) {
                TrackingService.recordEvent(
                  TRACKING_CATEGORY,
                  ShowroomService.getTrackingAction(),
                  'ShortenLinkUnselected',
                );
              }

              // TODO DEV-28858 DEL POST MULTI_LINKS LAUNCH
              _($scope.state.instances).each((url) => {
                if ($scope.model.shortenChecked) {
                  if (!_.isUndefined(url.shortLink)) {
                    url.urlToShow = url.shortLink;
                    url.hasCopiedLink = false;
                  } else {
                    url.shortLinkOutstandingAsync = 'getTribShortLink';
                    ShowroomApiService.getTributaryImplShortLinkAsync(
                      $scope.state.impl.id,
                      $scope.state.impl.name,
                      $scope.state.impl.sourceId,
                      'item', // From the UIA, only item sourceTypes are supported
                    )
                      .then((result) => {
                        if (result.shortLink) {
                          url.shortLink = result.shortLink;
                          url.urlToShow = url.shortLink;
                        } else {
                          // Creating a short link failed, disable the checkbox and show a message
                          angular
                            .element('.uia-tributary-shorten-link')
                            .attr('checked', false);
                          angular
                            .element('.uia-tributary-shorten-link')
                            .attr('disabled', true);
                          $scope.model.shortenLinkError = true;
                        }
                      })
                      .finally(() => {
                        url.shortLinkOutstandingAsync = null;
                        $scope.model.hasCopiedLink = false;
                      });
                  }
                } else {
                  url.urlToShow = url.longLink;
                  url.hasCopiedLink = false;
                }
              });
            };

            $scope.model.copyToClipboardClicked = () => {
              TrackingService.recordEvent(
                TRACKING_CATEGORY,
                ShowroomService.getTrackingAction(),
                'Copy',
              );
            };

            $scope.$on('copy-button:copied', (e) => {
              $scope.model.hasCopiedLink = true;
              e.stopPropagation();
            });

            // Select the adaptive link by default
            // TODO PORT
            $scope.$watch(
              () => {
                return angular
                  .element('.adaptive-link-text-container')
                  .is(':visible');
              },
              () => {
                angular.element('.adaptive-link-text-container').select();
              },
            );

            ShowroomService.getCurrentConfigStatusObservable().subscribe(
              (currentState) => {
                const oldLoadedState = $scope.state.loaded;
                $scope.state = angular.copy(currentState);

                // If this is the first load
                if (!oldLoadedState && $scope.state.loaded) {
                  $scope.model.shortenLinkChanged();
                }

                $scope.model.creatingLinkAsync = _(
                  $scope.state.outstandingAsyncActions,
                ).contains(SHOWROOM_ACTION_TYPES.ADD_NEW_INSTANCE);

                // TODO DEV-28858 Remove this once we've released multilinks, since that whole block can be removed
                $scope.model.showSaveRequiredMsg =
                  currentState.buttonState ===
                  SHOWROOM_BUTTON_STATE.SAVE_REQUIRED;
              },
            );

            ShowroomService.reloadState(universalItemId);
          },
        ],
        link(scope, element, attrs, universalImageActionsModalCtrl) {
          scope.model.currentlyInWorkflow =
            universalImageActionsModalCtrl.currentlyInWorkflow();

          // When the user clicks on the link text in the modal,
          // we'll automatically select all of the text for them. Note
          // that we unbind mouseup here because Chrome will deselect
          // text on mouseup after the focus event fires.
          // angular.element('.adaptive-link-text-container').focus(function() {
          //     const elem = angular.element(this);
          //     elem.select();
          //     elem.mouseup(() => {
          //         elem.unbind('mouseup');
          //         return false;
          //     });
          // });
        },
      };
    },
  ]);
})();
